module.exports = require("readline");


//////////////////
// WEBPACK FOOTER
// external "readline"
// module id = 62
// module chunks = 0